import { createRef, h } from "preact";
import { useNavigate } from "react-router-dom";
import { useContext } from "preact/hooks";

import { classNames } from "../helpers";
import i18n from "../i18n";

import Avatar from "./Avatar.jsx";
import Dropdown from "./Dropdown.jsx";
import TalentListItem from "./TalentListItem.jsx";
import CompanyLogo from "./CompanyLogo.jsx";
import { PreviewModeContext } from "../contexts";

export default function TopBarProfileMenu(props) {
  const navigate = useNavigate();
  const dropdownRef = createRef();
  const previewMode = useContext(PreviewModeContext);

  const avatar = props.company ? (
    <CompanyLogo company={props.company} plain />
  ) : (
    <Avatar user={props.user} plain />
  );

  if (props.isLoggedIn) {
    let title = props.user.name
      ? props.user.name
      : i18n.t("top_bar_profile_menu.logged_in");

    const items = [
      props.company
        ? null
        : {
            props: { "data-qa": "top-bar-profile-menu", role: "button" },
            content: (
              <TalentListItem
                class="top-bar-profile-menu__talent"
                user={props.user}
              />
            ),
            onClick: () => {
              dropdownRef.current.close();
              navigate("/profile");
            },
          },
      {
        props: { "data-qa": "settings-link", role: "button" },
        text: i18n.t("top_bar_profile_menu.settings"),
        onClick: () => {
          dropdownRef.current.close();
          navigate("/settings");
        },
      },
      props.company || props.user.talentPool == true
        ? {
            props: { "data-qa": "referral-link", role: "button" },
            text: i18n.t(
              props.company
                ? "top_bar_profile_menu.partner_program"
                : "top_bar_profile_menu.referral"
            ),
            onClick: () => {
              dropdownRef.current.close();
              navigate("/referral");
            },
          }
        : null,
      {
        props: { "data-qa": "logout-link", role: "button", class: "f-medium" },
        text: i18n.t("top_bar_profile_menu.logout"),
        onClick: async () => {
          dropdownRef.current.close();
          window.location.href = "/logout";
        },
      },
    ].filter((x) => x);

    return (
      <Dropdown
        ref={dropdownRef}
        items={items}
        dropdownClass="top-bar-profile-menu__dropdown"
      >
        <a
          href="#"
          class={classNames("top-bar-profile-menu", props.class)}
          onClick={() => dropdownRef.current.close()}
        >
          {avatar}
        </a>
      </Dropdown>
    );
  } else {
    return (
      <a
        href={previewMode ? "/preview/registration" : "/register"}
        class={classNames("top-bar-profile-menu", props.class)}
      >
        <span>{i18n.t("top_bar_profile_menu.signup")}</span>
        {avatar}
      </a>
    );
  }
}
